import { render, staticRenderFns } from "./BlockEditStage.vue?vue&type=template&id=7ef3c2ac&scoped=true&"
import script from "./BlockEditStage.vue?vue&type=script&lang=js&"
export * from "./BlockEditStage.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditStage.vue?vue&type=style&index=0&id=7ef3c2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef3c2ac",
  null
  
)

export default component.exports